import { getCookie } from 'cookies-next'
import { nextLocaleCookieKey } from './init-language-cookie'

export function getLanguageCookie() {
  return getCookie(nextLocaleCookieKey)
}
